module.exports = __webpack_public_path__ + "img/gift.9c024d8e.png";